import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { ClaimingUserDto } from "@services/Api/api.dto";
import { useApiClient } from "@services/Api/ApiClientContext";
import { useSelectedEvent } from "@app/panel/Events/contexts/SelectedEvent.context";
import { useEventsModals } from "@app/panel/Events/contexts/EventsModals.context";

import Portal from "@components/overlay/Portal/Portal";
import Backdrop from "@components/ux/Backdrop/Backdrop";
import Modal from "@components/overlay/Modal/Modal";
import Stack from "@components/arrangement/Stack/Stack";
import Group from "@components/arrangement/Group/Group";
import Button from "@components/dataEntry/Buttons/Button/Button";

import "./SendOccasionalNft.scss";

interface SendOccasionalNftProps {
  claimingUser: ClaimingUserDto;
}

const SendOccasionalNft = ({ claimingUser }: SendOccasionalNftProps) => {
  const [submitting, setSubmitting] = useState<boolean>(false);

  const { event } = useSelectedEvent();
  const { sendNftsToAllSelected } = useApiClient();
  const { closeModal } = useEventsModals();

  const { t } = useTranslation(["eventsModals", "common"]);

  const handleSendNft = () => {
    if (!claimingUser) return;

    setSubmitting(true);

    const emailsList = [{ email: claimingUser.email, ticketId: claimingUser.ticket.id }];

    sendNftsToAllSelected(event.id, emailsList)
      .then((res) => {
        if (res.status === 204) {
          closeModal();
        }
      })
      .finally(() => setSubmitting(false));
  };

  const descriptionContent = claimingUser.nftLastSentAt
    ? t("eventsModals:sendOccasionalNft.sendNftDescription")
    : t("eventsModals:sendOccasionalNft.againSendNftDescription");

  return (
    <Portal>
      <Backdrop open>
        <Modal onClose={closeModal}>
          <Stack className="send-occasional-nft-modal">
            <p className="p0 mt-6">{descriptionContent}</p>
            <p className="p0 bold">{claimingUser.email}</p>

            <Group colGap={20} className="mt-5">
              <Button type="submit" variant="primary" onClick={handleSendNft} disabled={submitting}>
                {t("common:send")}
              </Button>
              <Button variant="secondary" onClick={closeModal}>
                {t("common:cancel")}
              </Button>
            </Group>
          </Stack>
        </Modal>
      </Backdrop>
    </Portal>
  );
};

export default SendOccasionalNft;
